import React from "react";
import "./Pages.css";
import chat from "../../assets/chat.png";
import announcement from "../../assets/announcement.png"

const Anzeige = () => {
  return (
    <div className="anzeige">
      {/* */}
      <img width={300} src={announcement} alt="Anzeige" /><pre/>
      <p style={{color:"red"}}>
      <strong>Praxis geschlossen!</strong><pre/>
      Wegen einer ganztägigen Schulung bleibt meine Praxis am <pre/>
      Montag den 22.06.2026 geschlossen.<pre/>
      In dringenden Notfälle wenden Sie sich bitte an das nächstgelegene Krankenhaus!<pre/><pre/>
      <pre/>
      Ab Dienstag den 23.06.2026 ist die Praxis zu den gewohnten Zeiten geöffnet.<pre/>
        Ihr URO-Praxisteam<pre /><pre />
      </p><pre/><pre/> 
      <img width={300} src={chat} alt="Anzeige" />
      <p>
        Sehr geehrte Patienten <pre/>
        <pre/>
        Wir sind eine Facharztpraxis, da kann es schon durchaus zu etwas längeren
        Wartezeiten kommen. Dafür bitte wir um Verständnis.<pre/>
        <pre/>
        Die Untersuchung bei Neupatienten ist immer etwas aufwändiger. Bitte planen
        Sie genügend Zeit ein.<pre/>
        <pre/>
        Wir haben mehrere Untersuchungs-/Behandlungsräume, deswegen kann es
        auch durchaus sein, dass ein Patient, der nach Ihnen kam, vor Ihnen aufgerufen
        wird.<pre/>
        <pre/>
        Viele Patienten kommen z.B. nur zur Blutabnahme, Katheterwechsel usw. und
        müssen an diesem Tag nicht zum Arzt.<pre/>
        Das sind Untersuchungen, die von den Fachangestellten durchgeführt
        werden.<pre/>
        <pre/>
        An manchen Tagen haben wir auch Notfälle. Dies sind Patienten mit z.B.
        Koliken und unter Schmerzen können diese Patienten nicht warten und
        brauchen zeitnah eine Versorgung.<pre/>
        <pre/>
        Wir bitten um Ihr Verständnis<pre/>
        Ihr URO-Praxisteam<pre /><pre />
      </p>
    </div>
  );
};

export default Anzeige;
